import { init } from "../init";
import { ConfluenceSoftwarePage } from "../pages/software/confluence/anchors/confluence-software-page";
init(ConfluenceSoftwarePage);
